import { type User } from '@src/api/services/AuthenticationService';
import { UserRole } from '@funnellab/shared/src/dtos/UserDTO';

const userIsAdmin = (user: User) => user.role === UserRole.ADMINISTRATOR;

const userIsAgency = (user: User) => user.role === UserRole.AGENCY;

export const userHasAdminRights = (user: User) =>
  userIsAdmin(user) || userIsAgency(user);
